<template>
  <div :class="isOpen ? 'grey-background' : ''" class="hero-wrapper-header">
    <div id="header" class="hero-header">
      <div class="hero-logo">
        <a class="workera" :href="`${hubspotUrl}`">
          <img
            :class="$mq === 'desktop' ? 'logo' : 'logo-mobile'"
            v-lazy-load data-src="~/assets/img/moniker.png"
          />
        </a>
      </div>
      <div class="header-links-left" />
      <div v-if="$mq === 'desktop'" class="header-links">
        <!--span class="header-left"-->
        <span class="header-link">
          <a :href="'https://workera.ai/'">About Us</a>
        </span>
        <span class="header-link">
          <a :href="'https://workera.ai/careers/'">Careers</a>
        </span>
        <!--/span-->
        <!--div class="rigth-al"-->
        <span class="header-link">
          <a href="/app/login/">Log in</a>
        </span>

        <span>
          <a
            class="sign-up-cls header-link yellow-btn"
            href="/app/login/"
            >Sign Up</a
          >
        </span>
        <!--/div-->
      </div>
      <div
        v-else-if="$mq === 'tablet' || $mq === 'mobile'"
        class="header-links"
      >
        <Slide @openMenu="handleOpenMenu" @closeMenu="handleCloseMenu" right>
          <span class="menu-text"> Workera </span>
          <span>
            <a class="sign-up-cls-mobile" href="/app/login/"
              >Sign Up</a
            >
          </span>
          <span class="">
            <a href="/app/login/" class="button btn-yellow-border"
              >Log in</a
            >
          </span>
          <span class="header-link">
            <a :href="'https://workera.ai/'">About Us</a>
          </span>
          <span class="header-link">
            <a :href="'https://workera.ai/careers/'">Careers</a>
          </span>
        </Slide>
      </div>
    </div>
  </div>
</template>

<script>
// import { Slide } from 'vue-burger-menu'
export default {
  components: {},
  props: {
    isPartners: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    hubspotUrl: {
      type: String,
      default: process.env.hubspotUrl,
    },
  },
  data() {
    return {}
  },
  computed: {},
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleOpenMenu() {
      this.isOpen = true
    },
    handleCloseMenu() {
      this.isOpen = false
    },
    handleScroll() {
      // scroll handling here
      const header = document.getElementById('header')
      if (window.pageYOffset < 50) {
        header.classList.remove('white-backgorund')
        header.classList.remove('shadow')
      } else if (window.pageYOffset >= 50) {
        header.classList.add('white-backgorund')
        header.classList.add('shadow')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Assistant:400,500,600,700,800&display=swap');
.wrapper .hero-logo {
  max-width: 50%;
}

.shadow {
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.1);
  opacity: 1;
  transition: visibility 0.5s, opacity 2s linear;
}
.invisible {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.5s, opacity 3s linear;
}
.white-backgorund {
  background: white !important;
  transition: visibility 0.3s, background 0.5s linear;
}
.hero-logo {
  display: flex;
  align-items: center;
  height: 100%;
  min-width: 80px;
  max-width: 200px;
  flex: 1;
  margin-left: 5%;
}

.hero-header {
  align-items: baseline;
  display: flex;
  height: 100%;
  //  box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.1);
}

.header-links {
  margin: auto;
  float: right;

  flex-wrap: wrap;
  display: flex;
  align-items: center;
  z-index: 1000;
  margin-right: 5%;
}
.header-left {
  margin: auto;
  display: flex;
  align-items: left;
  margin-left: 2rem;
  z-index: 1000;
  position: absolute;
  left: 200px;
}

.header-link {
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
  align-items: center;
}

.header-link a {
  font-style: normal;
  font-size: 18px;
  font-weight: 600;
  line-height: 15px;
  margin-right: 2.5rem;
  /* identical to box height */

  z-index: 100;
  text-decoration: none;
  letter-spacing: 0.0347222px;

  color: #231f20;
}

.header-links .sign-up {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  padding-left: 2.3rem;
  padding-right: 2.3rem;
  display: block;
  /* identical to box height */
}

.hero-wrapper-header {
  width: 100%;
  height: 80px;
  background: transparent;
  font-family: Assistant;
  position: fixed;
  top: 0 !important;
  z-index: 100;
}

.transparent-btn {
  border-radius: 4px;
  border: 2px solid #f9cd46;
  color: #333333;
  font-weight: 500;
  text-decoration: none;
  padding: 1rem;
}
a.sign-up-cls {
  background-color: $primary-yellow !important;
  font-weight: 700 !important;
  box-shadow: none;
  color: black;
  min-width: 95%;
  min-height: 3rem;
  &:hover {
    background-color: $yellow-background-hover !important;
  }
}
a.sign-up-cls-mobile {
  background-color: $primary-yellow !important;
  font-weight: 700 !important;
  font-size: 16px;
  line-height: 20.93px;
  box-shadow: none;
  color: black;
  min-width: 95%;
  padding: 0.688rem;
  &:hover {
    background-color: $yellow-background-hover !important;
  }
}
</style>

<style lang="scss" scoped>
.bm-burger-bars {
  background-color: black;
}

.bm-item-list a {
  /*color: white ;*/
}

.bm-menu {
  z-index: 1000;
  background-color: white !important;
}

.header-link .btn-secondary {
  color: black;
  /*background: transparent !important;*/
  padding: 0;
  border: none;
  margin-right: 3.4rem;
  font-weight: 500;
  font-size: 1.1rem;
  font-family: Assistant;
}

.header-link .btn-secondary:active {
  color: black !important;
}

.header-links .btn-secondary:not(:disabled):not(.disabled):active,
.header-links .btn-secondary:not(:disabled):not(.disabled).active,
.header-links .show > .btn-secondary.dropdown-toggle {
  color: black !important;
}

.header-links .dropdown-item:hover,
.header-links .dropdown-item:focus {
  color: black;
  text-decoration: none;
  background-color: #f8d004;
}

.header-links .btn-secondary:focus {
  box-shadow: none;
  border: none !important;
}

.header-link .btn-secondary:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}

.white-button-blue-border {
  text-decoration: none !important;
  color: #0062cc;
  margin-right: 1.3rem;
  font-weight: 700;
  font-size: 16px;
  line-height: 20.93.93px;
  letter-spacing: 0.03px;
  padding: 0.566rem 1.2rem;
}

.button {
  text-decoration: none !important;
  background-color: #e6f5fa;
  color: #0062cc;
  padding: 0.688rem;
  border-radius: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 20.93.93px;
  letter-spacing: 0.03px;
  min-width: 95%;
}
.btn-blue {
  background-color: #0062cc;
  color: white;
}
.btn-blue:hover {
  color: white;
  text-decoration: none;
  background-color: #0747a6;
}
.logo-mobile {
  margin-left: 0px;
}
.btn-white {
  background-color: white;
  border-top: 2px solid #0062cc;
  border-right: 2px solid #0062cc;
  border-bottom: 2px solid #0062cc;
  border-left: 2px solid #0062cc;
  color: #0062cc !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 20.93px;
  letter-spacing: 0.03px;
  text-align: center;
}
.btn-white:hover {
  background-color: #f7f9fc;
}

.hr {
  width: 14rem;
  padding-bottom: 0;
}

.menu-text {
  color: #929292;
  font-weight: 700;
  font-size: 18px;
  line-height: 23.54px;
  font-family: Assistant;
}

.popover .arrow {
  display: none;
}
.popover {
  top: 2rem !important;
}

.popover-body {
  min-width: 12rem;
  font-family: Assistant;
}
.button1 {
  text-decoration: none;
  background-color: #e6f5fa;
  color: #0062cc;
  padding: 0.688rem;
  border-radius: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 20.93.93px;
  letter-spacing: 0.03px;
  min-width: 5rem;
}
.btn-size {
  width: 12rem;
  min-width: 10rem !important;
}
a.button.btn-white.btn-size {
  text-decoration: none !important;

  min-width: 10rem !important;
  padding-left: 4rem;
  padding-right: 4rem;
}
.inv {
  color: transparent;
}
#login:hover {
  cursor: pointer;
}
a#login:focus {
  outline: none;
}
.btn-yellow-border {
  background-color: white;
  border-top: 2px solid #f9cd46;
  border-right: 2px solid #f9cd46;
  border-bottom: 2px solid #f9cd46;
  border-left: 2px solid #f9cd46;
  color: black !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 20.93px;
  letter-spacing: 0.03px;
  text-align: center;
}

.btn-yellow-border:hover {
  background-color: #fef5da !important;
  text-decoration: none;
  font-weight: 700;
}
.cls-center {
  text-align: center;
}

.grey-background {
  background: gray !important;
}

.text-option {
  font-weight: 700;
  font-size: 18px;
  line-height: 23.54;
}

.bm-item-list {
  margin-left: 5% !important;
}
.bm-burger-button {
  top: 1.7rem !important;
}
</style>
